import wrapperStyles from "../../../styles/UI/wrappers.module.css";

const ColouredRoundWrapper = ({
  children,
  classes,
  bgColor,
  borderColor,
  height,
  padding,
  color,
  width,
  maxWidth,
  onClick,
  onMouseEnter,
  onMouseLeave,
}: {
  children: React.ReactNode | React.ReactNode[];
  classes?: string;
  bgColor: string;
  borderColor?: string;
  height?: string;
  padding?: boolean;
  color?: string;
  width?: string;
  maxWidth?: string;
  onClick?: () => void;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
}) => {
  return (
    <div
      className={`${wrapperStyles.colouredRoundWrapper} ${classes ? classes : null}`}
      style={{
        color: color,
        border: `1px solid ${borderColor ? borderColor : "transparent"}`,
        backgroundColor: bgColor,
        width: width ? width : "fit-content",
        maxWidth: maxWidth ? maxWidth : "unset",
        height: height ? height : "40px", //Todo: update to util variable
        padding: padding ? "var(--spacing-sm) var(--spacing-md)" : "none",
      }}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      {children}
    </div>
  );
};

export default ColouredRoundWrapper;
